// ----------------------------------------------------------------------------
// Modal
// ----------------------------------------------------------------------------
//
// Modal poopup
//
// ----------------------------------------------------------------------------

import $ from 'jquery';
var _ = require('lodash');

// Constant trigger classes
var modal               = '.modal';
var modalOpen           = '.modal--open';
var modalOverlay        = '.modal__overlay--close';
var closeButton         = '.modal__close-button';
var openButton          = '.modal__trigger';
var firstFocusElement   = '.first-focusable-element';
var lastFocusElement    = '.last-focusable-element';


var MODAL = {

    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    open: function($modal) {
        // Open the Modal
        $modal.addClass('modal--open');

        // Move focus from the triggrt button to the modal close button
        document.querySelector(closeButton).focus();

        $('body').addClass('noscroll');

        // Broadcast a notification that a modal opened
        $(window).trigger('open.modal', $modal);

        // Trap keyboard focus by moving focus to the first or last focusable element when the user tries to tab (or "backwards" tab) past them.
        $modal.on('keydown', function(e) {
            if(e.target == document.querySelector(firstFocusElement) && e.key == 'Tab' && e.shiftKey) {
              e.preventDefault();
              document.querySelector(lastFocusElement).focus();
            } else if(e.target == document.querySelector(lastFocusElement) && e.key == 'Tab' && !e.shiftKey) {
              e.preventDefault();
              document.querySelector(firstFocusElement).focus();
            }
        });
    },

    /**
     * [eventCloseModal - Closes up the modal, un-position:fix's body, and removes overlay]
     * @param {Event} e
     * @return void
     */
    close: function(e) {
        // Determine which modal(s) are open
        var $openModals = $(modalOpen);

        // Close all modals
        $openModals.removeClass('modal--open');

        $('body').removeClass('noscroll');

        // Broadcast a notification that a modal closed
        $.each($openModals, function(index, openModal) {
            $(window).trigger('close.modal', openModal);
        
            if (typeof e !== 'undefined' && e.which == 1) { // Mouse click
                // Do nothing
            } else {
                if ($(openModal).attr('data-focus-element')) {
                    $(`[data-product-sku="${$(openModal).attr('data-focus-element')}"]`).focus();
                } else {
                    // Move focus back to the trigger button when the modal is closed
                    document.querySelector(openButton).focus();
                }
            }
        });
    },


    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    clickTrigger: function(event) {
        // Get the modal associated with the target
        var $modal = $('#modal_' + $(event.currentTarget).data('modal-target'));
        
        if ($(event.currentTarget).hasClass('btn--add-to-cart--quick')) {
            $modal.attr('data-focus-element', $(event.currentTarget).attr('data-product-sku'));
        }

        this.open($modal);
    }
};


/**
 * Bind Modal Triggers
 */
$(document).ready(function() {
    $(document).on('click', openButton, _.bind(MODAL.clickTrigger, MODAL));
    $(document).on('click keypress', closeButton,  _.bind(MODAL.close));
    $(document).on('click', modalOverlay, _.bind(MODAL.close));

    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) { // Esc key
            MODAL.close();
        }
    });
})

export default MODAL;
